import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import ListItemsSelectNavigationContainer from "@/components/layouts/ListItemsSelectNavigationContainer/ListItemsSelectNavigationContainer.vue";
import { IListItem } from "@/types/list";
import { computed } from "vue";
import { getSettingsChangeLanguageMenuItems } from "../../utils/settings";


export default /*#__PURE__*/_defineComponent({
  __name: 'SettingsChangeLanguage',
  setup(__props) {

const settingsChangeLanguageMenuItems = computed<IListItem[]>(() => {
  return getSettingsChangeLanguageMenuItems();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ListItemsSelectNavigationContainer, {
    "navigation-title": _ctx.$t('settings.changeLanguage'),
    "lists-array": [settingsChangeLanguageMenuItems.value]
  }, null, 8, ["navigation-title", "lists-array"]))
}
}

})